import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, CreditCard, ShoppingBag, LogOut, Palette } from 'lucide-react';

export default function ArtistLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const artistData = JSON.parse(localStorage.getItem('artist_data') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('artist_token');
    localStorage.removeItem('artist_data');
    navigate('/artist/login');
  };

  const menuItems = [
    { path: '/artist/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/artist/cards', label: 'My Cards', icon: CreditCard },
    { path: '/artist/orders', label: 'Orders', icon: ShoppingBag },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-64 bg-gradient-to-b from-purple-600 to-pink-600 text-white flex flex-col">
        <div className="p-6 border-b border-purple-500">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
              <Palette className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <h1 className="font-bold text-lg">Artist Portal</h1>
              <p className="text-xs text-purple-100">Smart Connections</p>
            </div>
          </div>
        </div>

        {/* Artist Info */}
        {artistData.name && (
          <div className="p-6 border-b border-purple-500">
            <div className="flex items-center gap-3">
              {artistData.profile_picture ? (
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001'}${artistData.profile_picture}`}
                  alt={artistData.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-white"
                />
              ) : (
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-purple-600 font-bold text-xl">
                  {artistData.name.charAt(0)}
                </div>
              )}
              <div>
                <p className="font-semibold">{artistData.name}</p>
                <p className="text-xs text-purple-100">{artistData.email}</p>
              </div>
            </div>
          </div>
        )}

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-white text-purple-600 font-semibold'
                    : 'text-purple-100 hover:bg-purple-500'
                }`}
              >
                <Icon className="w-5 h-5" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="p-4 border-t border-purple-500">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-purple-100 hover:bg-purple-500 transition-colors w-full"
          >
            <LogOut className="w-5 h-5" />
            Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
}
